import React from 'react'
import { Link } from "react-router-dom";

export function AccessFormationLogin() {
    return (

        <>
        <div className="card md:h-72 bg-white px-2 py-2 md:p-6">
                <h1 className="pb-2 ml-1 font-medium text-lg flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-building-warehouse mx-2 h-6 w-6 stroke-neutral-800 md:hidden" viewBox="0 0 24 24" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 21v-13l9 -4l9 4v13" />
                        <path d="M13 13h4v8h-10v-6h6" />
                        <path d="M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3" />
                    </svg>
                    <span>Formación</span>
                </h1>
                <div className="card-body py-1 px-4 flex justify-center items-center flex-column">
                    <h3 className="font-medium text-lg text-neutral-500">EXPLORA NUESTRA SELECCIÓN DE CURSOS FORMATIVOS</h3>
                    <p className="my-2 text-sm text-neutral-500">En esta sección, podrás encontrar todas las acciones formativas que se desarrollan desde el ICOFCV, así como todos los cursos, jornadas, congresos, etc. que promociona el Colegio. ¡Accede y comienza a planificar tu formación!</p>
                    <div className="card-actions flex justify-center mb-2">
                        <Link to="/college/formationlist" className="bg-teal-600 hover:bg-teal-800 text-white px-8 py-2 mt-2 flex items-center justify-center mx-auto w-auto rounded">
                            <span className="ml-2">Acceso Formación</span>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}